const column = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        return (
            <div {...attributes} {...element.attributes}>
                {children}
            </div>
        );
    },
};

export default column;
